import React from 'react';

import { BenefitsTabName } from '@epi-constants/beneficiary';
import { Tabs } from 'edenred-ui';

import { useBeneficiaryTabs } from './hooks/useBeneficiaryTabs';

const BeneficiariesModalContent = ({
  beneficiaryId,
  handleSubmit,
  submit,
  isShowModal
}: {
  beneficiaryId: string | null;
  handleSubmit: any;
  submit: () => Promise<void>;
  isShowModal: boolean;
}) => {
  const { tabs } = useBeneficiaryTabs(!beneficiaryId, isShowModal);

  return (
    <form onSubmit={handleSubmit(submit)} id="beneficiary-form">
      <Tabs tabs={tabs} defaultTabName={BenefitsTabName.personalData} />
    </form>
  );
};

export default BeneficiariesModalContent;
